import { createSelector } from '@reduxjs/toolkit';
import { handleActions } from 'redux-actions';
import { VISITS_MODULE } from '../../configs/moduleNames';
import {
  createLoadListReducerWithBegin, createLoadParameterReducer,
} from '../../utils/getCrudConfig';
import { LOAD_VISIT_BY_ID, LOAD_VISIT_LIST } from './actions';

const initialState = {
  visitList: [],
  visitListMeta: {},
  loadingVisitList: false,
  currentVisit: {},
  loadingCurrentVisit: false,
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(VISITS_MODULE + LOAD_VISIT_LIST, 'visitList', 'loadingVisitList'),
  ...createLoadParameterReducer(VISITS_MODULE + LOAD_VISIT_BY_ID, 'currentVisit', 'loadingCurrentVisit'),
}, initialState);

export default reducer;

export const getVisitData = createSelector(
  [state => state[VISITS_MODULE]],
  state => {
    const {
      visitList,
      loadingVisitList,
      visitListMeta,
      currentVisit,
      loadingCurrentVisit,
    } = state;

    return {
      visitList,
      loadingVisitList,
      visitListMeta,
      currentVisit,
      loadingCurrentVisit,
    };
  },
);
